import {
  AudioSource,
  PLAYBACK_STATUS_UPDATE,
  createAudioPlayer,
  setAudioModeAsync,
} from 'expo-audio';

setAudioModeAsync({
  playsInSilentMode: true,
  interruptionMode: 'mixWithOthers',
  interruptionModeAndroid: 'duckOthers',
});

/** easily and efficiently play sound once cleaning up resources afterwards */
export const playAudioOnce = (source: AudioSource | string | number | null = null) => {
  if (!source) {
    return;
  }

  const player = createAudioPlayer(source);
  const subscription = player.addListener(PLAYBACK_STATUS_UPDATE, status => {
    if (status.didJustFinish) {
      player.release();
      subscription.remove();
    }
  });
  player.play();
};
